import {
    ParagraphValores,
    ParagraphTextoValores,
    ContainerValores,
} from './styles';

interface SummaryCardField {
    name: string;      
    label: string;     
    col?: number;      
    prefix?: string;
}

interface SummaryCardsProps {
    fields: Array<SummaryCardField>;
    initialValues?: any;
    gap?: string;
    margin?: string;
}

const SummaryCards = ({ fields, initialValues = {}, gap, margin }: SummaryCardsProps) => {

  const getValue = (fieldName: string) => {
    const val = initialValues?.[fieldName];
    // Verifica se existe valor, senão retorna '--'
    return val !== undefined && val !== null ? val : '--';
  };

  return (
    <div className={`grid grid-cols-12 ${gap || 'gap-4'} ${margin || 'my-4'}`}>
      {fields.map((f, index) => (
        <div 
          key={f.name || index} 
          className={`col-span-${f.col || 4}`} 
        >
          <ContainerValores style={{ width: '100%', height: '100%' }}>
            
            <ParagraphValores>
              {f.prefix ? `${f.prefix} ` : 'R$ '} 
              {getValue(f.name)}
            </ParagraphValores>
            
            <ParagraphTextoValores>
              {f.label}
            </ParagraphTextoValores>

          </ContainerValores>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;